
import PrescalesTable from '../PrescalesTable.vue'

import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { mapGetters, mapActions } from 'vuex'

@Component({
  computed: {
    ...mapGetters({
      getTreeRefsMap: 'getTreeRefsMap',
      getConfigNodesMap: 'getConfigNodesMap',
      getForcedOpenNodeIds: 'getForcedOpenNodeIds',
      getOpenNodeIds: 'getOpenNodeIds',
      getForcedActiveNodeId: 'getForcedActiveNodeId',
      getDarkMode: 'getDarkMode',
      getIDCounter: 'getIDCounter',
      getTopLevelNodeNameReferenceIDsMap: 'getTopLevelNodeNameReferenceIDsMap',
      getTopLevelDatasetNameToIdMap: 'getTopLevelDatasetNameToIdMap',
    }),
  },
  methods: {
    ...mapActions({
      setSnackBarText: 'setSnackBarText',
      setSelectedNodeViaID: 'setSelectedNodeViaID',
    }),
  },
  components: {
    PrescalesTable,
  },
})
export default class TreeViewTopNode extends Vue {
  @Prop(String) parentType!: string
  @Prop(Number) parentItemId!: number
  @Prop(Array) items!: Array<Object>
  @Prop(Object) iconTypes!: Object
  @Prop(Object) iconColors!: Object
  @Prop(String) search!: String
  @Prop(Boolean) searchDeep!: Boolean

  @Watch('getForcedActiveNodeId')
  // eslint-disable-next-line no-unused-vars
  onForcedActiveChanged(val: any, oldVal: any) {
    //console.log('active VAL:' + val)
    //console.log('active OLDVAL: ' + oldVal)
    if (val == this.parentItemId) {
      this.$nextTick().then(() => {
        //console.log('PARENT: ' + this.parentItemId)
        //console.log('FORCED: ' + this.getForcedActiveNodeId)
        //console.log('onForcedActiveChanged TRIGGERED')
        if (this.open.indexOf(this.parentItemId) == -1) {
          this.open.push(this.parentItemId)
        }
      })
    }
  }

  private open: any = []
  private active: any = []
  private forcedActive: any = []

  //Vuex getters
  private getTreeRefsMap!: Object
  private getConfigNodesMap!: Object
  private getTopLevelDatasetNameToIdMap!: Object
  private getForcedActiveNodeId!: Number

  //Vuex actions
  private setSnackBarText!: (payload: {
    snackBarText: string
    snackBarColor: string
  }) => Promise<any>
  private setSelectedNodeViaID!: (payload: {
    selectedNodeId: number
    forceOpenNode: boolean
  }) => Promise<any>

  //methods
  get myFilter() {
    return (item, search, textKey) => {
      if (this.search != null && search != '') {
        if (item[textKey].indexOf(search) > -1) {
          return true
        } else {
          //deep search?
          if (this.searchDeep)
            if (this.recurseDisplayLazy(item)) {
              return true
            }
          return false
        }
      } else {
        return false
      }
    }
  }

  public recurseDisplayLazy(item: Object): boolean {
    if (item['children'] != undefined) {
      for (let i = 0; i < item['children'].length; i++) {
        if (item['children'][i]['name'].indexOf(this.search) > -1) {
          return true //if found return immidiately
        }
      }
      //go in recursion
      for (let i = 0; i < item['children'].length; i++) {
        if (this.recurseDisplayLazy(item['children'][i])) return true
      }
    }
    return false
  }

  public checkIfNodeIsParamType(itemType: string): boolean {
    if (
      itemType.indexOf('cms.') != -1 ||
      itemType == 'string' ||
      itemType == 'int32' ||
      itemType == 'double' ||
      itemType == 'VPSet' ||
      itemType == 'PSet' ||
      itemType == 'untracked.PSet' ||
      itemType == 'untracked.VPSet' ||
      itemType == 'InputTag'
    )
      return true
    else return false
  }

  public checkIfNodeIsString(itemType: string): boolean {
    if (itemType == 'string' || itemType == 'cms.string') return true
    else return false
  }

  //Very important function, basically decides which node is clicked upon and gets all info about it
  public updateOpenNodes(array: any): void {
    //console.log('THIS OPEN BEFORE: ' + this.open)
    let difference: number = parseInt(
      this.open
        .filter((x) => !array.includes(x))
        .concat(array.filter((x) => !this.open.includes(x)))
    )

    if (Object.keys(this.getConfigNodesMap).length !== 0) {
      this.fetchNodeById(difference)
    }
    if (!isNaN(difference)) {
      if (this.open.indexOf(difference) == -1) this.open = array
      else {
        this.open.splice(this.open.indexOf(difference), 1)
      }
    }
    //console.log('THIS OPEN AFTER: ' + this.open)
    this.active = [] //clear active when node opens
  }

  public updateActiveNodes(array: any): void {
    let difference: number = parseInt(
      this.active
        .filter((x) => !array.includes(x))
        .concat(array.filter((x) => !this.active.includes(x)))
    )
    if (array.length != 0) difference = array[0]
    if (Object.keys(this.getConfigNodesMap).length !== 0) {
      this.fetchNodeById(difference)
    }
    this.active = array
  }

  async fetchNodeById(itemId: number): Promise<void> {
    //console.log('PARENT ID: ' + this.parentItemId)
    //console.log('ITEM ID: ' + itemId)
    //console.log('NODE: ' + JSON.stringify(this.getConfigNodesMap[itemId]))
    if (
      this.getConfigNodesMap[itemId] == undefined ||
      this.checkIfNodeIsParamType(this.getConfigNodesMap[itemId].type) //don't fetch params
    ) {
      if (isNaN(itemId)) return
      if (this.checkIfNodeIsString(this.getConfigNodesMap[itemId].type)) {
        //handle stream to dataset linking - get the ID of the dataset
        let dataSetName = this.getConfigNodesMap[itemId].paremeterJSONValue
        let dataSetID = this.getTopLevelDatasetNameToIdMap[dataSetName]

        console.log('DATASET ID: ' + dataSetID)

        await this.setSelectedNodeViaID({
          selectedNodeId: dataSetID,
          forceOpenNode: true,
        })
      }
      return
    }

    if (this.getConfigNodesMap[itemId].rootNodeId != itemId) {
      itemId = this.getConfigNodesMap[itemId].rootNodeId
      //console.log('ROOT NODE ID: ' + itemId)

      await this.setSelectedNodeViaID({
        selectedNodeId: itemId,
        forceOpenNode: false,
      })
    } else
      await this.setSelectedNodeViaID({
        selectedNodeId: itemId,
        forceOpenNode: false,
      })
  }

  public showRightClickMenu(e: any, itemType: string, itemId: number): void {
    e.preventDefault()

    let rightClickObject = {
      rightClickNodeType: itemType,
      rightClkNodeId: itemId,
      showMenu: false,
      x: e.clientX,
      y: e.clientY,
    }
    this.$emit('rightMenuClicked', rightClickObject)

    //this.rightClickNodeType = itemType
    //this.rightClkNodeId = itemId

    console.log('RIGHT CLICK ITEM TYPE: ' + itemType)
    console.log('RIGHT CLICK ITEM ID: ' + itemId)
    this.fetchNodeById(itemId)

    //this.showMenu = false
    //console.log('SET FALSE')
    //this.x = e.clientX
    //this.y = e.clientY
    //this.$nextTick(() => {
    //this.showMenu = true
    //console.log('SET TRUE')
    //})
  }

  updated() {
    //console.log('UPDATED TOP NODE')
    if (this.getForcedActiveNodeId == this.parentItemId) {
      this.$nextTick().then(() => {
        //console.log('PARENT: ' + this.parentItemId)
        //console.log('FORCED: ' + this.getForcedActiveNodeId)
        //console.log('onForcedActiveChanged TRIGGERED')
        if (this.open.indexOf(this.parentItemId) == -1) {
          this.open.push(this.parentItemId)
        }
      })
    }
  }

  mounted() {    
    if (this.getForcedActiveNodeId == this.parentItemId) {
      this.$nextTick().then(() => {
        //console.log('PARENT: ' + this.parentItemId)
        //console.log('FORCED: ' + this.getForcedActiveNodeId)
        //console.log('onForcedActiveChanged TRIGGERED')
        if (this.open.indexOf(this.parentItemId) == -1) {
          this.open.push(this.parentItemId)
        }
      })
    }
  }
}
